import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;

	${({ isUpdating }) => (isUpdating ? `opacity: 0.5` : '')};
`;

export const LoadingContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 10;
	background-color: rgba(255, 255, 255, 0.8);
`;

export const NavWrapper = styled.div`
	height: 49px;
	min-height: 49px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid ${colors.grey3};
	padding: 0 32px;
	background-color: ${colors.white};
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	z-index: 1;

	& button:first-child {
		margin-right: auto;
	}
`;

export const ControlGroup = styled.div`
	padding-left: 9px;
`;

export const CheckboxLabel = styled.div`
	line-height: 24px;
	font-size: 16px;
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey3};
	height: 24px;
	margin: 0 16px;
	align-self: center;
`;
